import { Layout, Select } from 'antd';
import queryString from 'query-string';
// store
import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../../api';
import { EditLocalSellersAuth } from '../../pages/Dashboard/LocalSellersPage/EditLocalSellerAuth';
import { useAuthStore } from '../../store';
import { removeAuthToken } from '../../utils/authToken';
import * as Icon from 'react-feather';
import { LogoutIcon } from './icons';
import { usePersistedShopId } from '../../hooks/usePersistedShopId';
import TaskIcon from '../TaskIcon';
import TaskDrawer from '../TaskDrawer';
import NotificationBell from '../NotificationBell';

export const Header = () => {
  const { isAuthenticated, removeAuth, user } = useAuthStore();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [sellerById, setSellerById] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(true);
  const [companyData, setCompanyData] = useState([]);
  const [sellerData, setSellerData] = useState<any>([]);
  const [shops, setShops] = useState<any>([]);
  const { shopId, setPersistedShopId } = usePersistedShopId();

  const { search } = useLocation();

  const handleLogout = () => {
    removeAuthToken();
    removeAuth();
  };

  const handleSetParams = (user_id: any, action: 'edit-local-auth' | null) => () => {
    navigate(
      {
        search: queryString.stringify(
          { ...searchParsed, user_id, action, shopId },
          { skipNull: true },
        ),
      },
      { replace: true },
    );
  };

  const searchParsed = useMemo(() => queryString.parse(search), [search]);

  const getShops = async () => {
    api('shops', 'GET', null)
      .then(({ statusIsOk, statusMessage, result }) => {
        if (!statusIsOk) handleSetError(statusMessage);
        if (statusIsOk) {
          setShops(result);
        }
      })
      .catch(({ statusMessage }) => handleSetError(statusMessage));
  };

  const getUserById = async () => {
    api('local-seller/getSellerByUserId/' + user?.id, 'GET', null)
      .then(({ statusIsOk, statusMessage, result }) => {
        if (!statusIsOk) handleSetError(statusMessage);
        if (statusIsOk) {
          setCompanyData(result?.company);
          setSellerData(result?.seller);
          showEditLocalSeller();
        }
      })
      .catch(({ statusMessage }) => handleSetError(statusMessage));
  };

  const handleSetError = (msg: string) => {
    // toastNotification('error', msg);
    setLoading(false);
  };

  const showEditLocalSeller = () => setVisible(true);

  const handleShopChange = (shopId: string) => {
    setPersistedShopId(shopId);
    window.location.reload();
  };

  useEffect(() => {
    getUserById();
    getShops();
  }, []);

  return (
    <div className="header__wrapper-sticky">
      <EditLocalSellersAuth
        visible={visible}
        disabled={disabled}
        setDisabled={setDisabled}
        sellerById={sellerById}
        setTableLoading={setLoading}
        companyData={companyData}
        sellerData={sellerData}
      />
      <TaskDrawer />
      <Layout.Header
        className={`site-layout-background header-layout ${shopId === '2' ? 'albania-header' : ''}${
          shopId === '3' ? 'slovenia-header' : ''
        }${shopId === '4' ? 'macedonia-header' : ''}`}
      >
        {isAuthenticated && (
          <>
            <div>
              {user?.roles.includes('Local Seller') && sellerData.is_suspended == true && (
                <p style={{ color: `${shopId === '2' ? 'white' : 'red'}`, display: 'contents' }}>
                  Your account has been suspended. Please contact Foleja team!
                </p>
              )}
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div className="user_header" onClick={handleSetParams(user?.id, 'edit-local-auth')}>
                <span className="image__user-header">
                  <Icon.User color="#ffffff" size={20} className="permissions-icon-tick" />
                </span>
                <div className="welcome__user">
                  <p>Welcome</p>
                  <span>{user?.fullName}</span>
                </div>
              </div>
              {user?.roles.includes('Admin') ||
                (user?.roles.includes('Super Admin') && (
                  <>
                    <Select
                      value={shopId}
                      onChange={handleShopChange}
                      placeholder="Select Shop"
                      style={{ width: 200, marginLeft: 'auto', marginRight: 20 }}
                    >
                      {shops.map((shop: any) => (
                        <Select.Option key={shop.id}>{shop.name}</Select.Option>
                      ))}
                    </Select>
                    <div style={{ marginRight: 20 }}>
                      <TaskIcon />
                    </div>
                  </>
                ))}
              <NotificationBell />
              <span onClick={handleLogout}>
                <LogoutIcon />
                Logout
              </span>
            </div>
          </>
        )}
      </Layout.Header>
    </div>
  );
};
